module.exports = __webpack_public_path__ + "media/images/pic/brodno/gallery/2020/pygmalion/thumbs/4-a18f412b02f6e341008080ce04cb4cb4.webp";